import React, { useState } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';

export const AddressBoxFilter = ({ searching, submitSearch }) => {
  const [searchProp, setSearchProp] = useState('');

  return (
    <Form.Group>
      <Form.Label>Buscar por Dirección</Form.Label>

      <InputGroup>
        <Form.Control
          type="text"
          size=""
          value={searchProp}
          placeholder="..."
          onChange={e => setSearchProp(e.target.value)}
          disabled={searching}
        />
        <InputGroup.Text className="p-0" style={{ overflow: 'hidden' }}>
          {searching ? (
            <Button
              size=""
              variant="danger"
              onClick={() => {
                submitSearch('');
                setSearchProp('');
              }}
              className="rounded-0"
            >
              <FontAwesomeIcon icon={['fas', 'times']} />
            </Button>
          ) : (
            <Button
              size=""
              onClick={() => submitSearch(searchProp)}
              className="rounded-0"
            >
              <FontAwesomeIcon icon={['fas', 'search']} />
            </Button>
          )}
        </InputGroup.Text>
      </InputGroup>
    </Form.Group>
  );
};
AddressBoxFilter.propTypes = {
  searching: PropTypes.bool.isRequired,
  submitSearch: PropTypes.func.isRequired
};
